export default {
  boardModalBigGraphMobile: {
    margin: 'auto',
    width: '100%',
    marginBottom: 5,
    backgroundColor: 'black',
  },
  boardModalSmallGraph: {
    marginLeft: '5%',
    height: '130px',
    width: 'calc(90% - 30px)',
    top: 0,
    background: '#fff',
  },
  boardModalBigGraph: {
    margin: 'auto',
    width: '90%',
    backgroundColor: 'black',
  },
  boardModalContent: {
    position: 'absolute',
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '50%',
    backgroundColor: 'white',
    padding: '5px',
    overflowY: 'auto',
  },
  modalCloseButtonMobile: {
    cursor: 'pointer',
    marginLeft: '90%',
    borderRadius: '50%',
    top: '0',
    padding: '8px',
    marginTop: '5px',
    position: 'fixed',
    background: '#fff',
    color: '#666',
    textAlign: 'center',
  },
  modalCloseButton: {
    cursor: 'pointer',
    marginLeft: '90%',
    borderRadius: '50%',
    top: '0',
    padding: '8px',
    marginTop: '10px',
    position: 'fixed',
    background: '#fff',
    color: '#666',
    textAlign: 'center',
  },

  boardModalData: {
    marginBottom: '40px',
    marginTop: '40px',
  },
  boardModalContentMobile: {
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    position: 'absolute',
    width: '95%',
    backgroundColor: 'white',
    padding: '0px',
    overflowY: 'auto',
  },
};



// WEBPACK FOOTER //
// ./src/components/Modals/RRDollarModal/styles.js